import {
  Error,
  ADD_JopTitle,
  UPDATE_JopTitle,
  DELETE_JopTitle,
  GET_JopTitle,
} from "../type";
const initialState = {
  AddJopTitle: [],
  GetJopTitle: [],
  UpdateJopTitle: [],
  DeleteJopTitle: [],
};
const JopTitleR = (state = initialState, action) => {
  switch (action.type) {
    case GET_JopTitle:
      return {
        ...state,
        GetJopTitle: action.payload,
      };
    case ADD_JopTitle:
      return {
        GetJopTitle: state.GetJopTitle,
        AddJopTitle: action.payload,
      };
    case UPDATE_JopTitle:
      return {
        GetJopTitle: state.GetJopTitle,
        UpdateJopTitle: action.payload,
      };
    case DELETE_JopTitle:
      return {
        GetJopTitle: state.GetJopTitle,
        DeleteJopTitle: action.payload,
      };
    case Error:
      return {
        GetJopTitle: action.payload,
      };
    default:
      return state;
  }
};
export default JopTitleR;
